import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import './Slibar.less'
import navbar_logo from 'assets/logo-small.png'
import slibar1Active from 'assets/slibar/slibar1-active.png'
import slibar2Active from 'assets/slibar/slibar2-active.png'
import slibar3Active from 'assets/slibar/slibar3-active.png'
import slibar4Active from 'assets/slibar/slibar4-active.png'
import slibar5Active from 'assets/slibar/slibar5-active.png'
import slibar6Active from 'assets/slibar/slibar6-active.png'
import slibar7Active from 'assets/slibar/slibar7-active.png'
import slibar1 from 'assets/slibar/slibar1.png'
import slibar2 from 'assets/slibar/slibar2.png'
import slibar3 from 'assets/slibar/slibar3.png'
import slibar4 from 'assets/slibar/slibar4.png'
import slibar5 from 'assets/slibar/slibar5.png'
import slibar6 from 'assets/slibar/slibar6.png'
import slibar7 from 'assets/slibar/slibar7.png'
import {
  dashboardApi,
  useGetMenuQuery,
} from "services/dashboardService";
import { useSelector, useDispatch } from "react-redux";


export default function Slibar() {
  const { data: menuData } = useGetMenuQuery({ stationId: '' });
  const [slibarList, setSlibarList] = useState<any[]>([])
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState<number | undefined>(0);
  const location = useLocation();
  const handleClickLogo = () => {

  }

  const dispatch = useDispatch(); 

  useEffect(() => {
    dispatch(
			dashboardApi.endpoints.getMenu.initiate(
				{
					userName: "111",
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
  }, [dispatch])

  useEffect(() => setCurrentTab(setTabIndex), [location, slibarList]);

  const setCurrentTab = (setTabIndex: React.Dispatch<React.SetStateAction<number | undefined>>) => {

    const path = window.location.pathname;
    if (path.startsWith("/dashboard")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'dashboard')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/stations/")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'dashboard')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/chargers")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'chargers')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/transactions")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'Sessions')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/users")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'users')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/pricing")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'pricing')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/fleets")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'fleet')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/analysis")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'analysis')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/team")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'team')
      })
      setTabIndex(index);
    }

    else if (path.startsWith("/access")) {
      const index = slibarList.findIndex((item: any) => {
        return isEqualIgnoreCase(item.text, 'access')
      })
      setTabIndex(index);
    }

    else {
      setTabIndex(undefined);
    }

  };

  interface MenuList {
    img: string,
    text: string,
    active: boolean,
    path: string,
  }

  let list: MenuList[] = []

  let listArr = []

  useEffect(() => {
    if(menuData) {
      listArr = menuData.map((el) => {
        if(el instanceof Object) {
          let elArr = Object.keys(el)
          return elArr[0]
        }else{
          return el
        }
      })
      list = listArr.map((it:any, idx) => {
        let text = it
        it = {}
        it.text = text
        if(text == 'Dashboard') {
          it.img = slibar1Active
          it.active = true
        }else if(text == 'Chargers') {
          it.img = slibar2
          it.active = false
        }else if(text == 'Sessions') {
          it.img = slibar3
          it.active = false
        }else if(text == 'Users') {
          it.img = slibar4
          it.active = false
        } else if(text == 'Access') {
          it.img = slibar4
          it.active = false
        }else if(text == 'Pricing') {
          it.img = slibar5
          it.active = false
        }else if(text == 'Fleet') {
          it.img = slibar6
          it.active = false
        }else if(text == "Analysis") {
          it.img = slibar7
          it.active = false
        }else if(text == 'Team') {
          it.img = slibar7
          it.active = false
        }else{
          it.img = slibar7
          it.active = false
        }
        return it
      }) as MenuList[]

    }
    list.forEach((it, idx) => {
      if (tabIndex == idx) {
        it.active = true
        switch (idx) {
          case 0:
            it.img = slibar1Active
            break
          case 1:
            it.img = slibar2Active
            break
          case 2:
            it.img = slibar3Active
            break
          case 3:
            it.img = slibar4Active
            break
          case 4:
            it.img = slibar5Active
            break
          case 5:
            it.img = slibar6Active
            break
          case 6:
            it.img = slibar7Active
            break
          case 7:
            it.img = slibar7Active
            break
        }
      } else {
        it.active = false
        switch (idx) {
          case 0:
            it.img = slibar1
            break
          case 1:
            it.img = slibar2
            break
          case 2:
            it.img = slibar3
            break
          case 3:
            it.img = slibar4
            break
          case 4:
            it.img = slibar5
            break
          case 5:
            it.img = slibar6
            break
          case 6:
            it.img = slibar7
            break
        }
      }
    })
    setSlibarList(list)
  }, [menuData, tabIndex])

  const isEqualIgnoreCase = (str1: string, str2: string) => {
    return str1.toLowerCase() === str2.toLowerCase()
  }

  const slibarTap = (index: number, text: string) => {
    const list = [...slibarList]
    setTabIndex(index)
    switch (text) {
      case "Dashboard":
        navigate("/dashboard")
        break
      case "Chargers":
        navigate("/chargers")
        break
      case "Sessions":
        navigate("/transactions")
        break
      case "Users":
        navigate("/users")
        break
      case "Access":
        navigate("/access")
        break
      case "Pricing":
        navigate("/pricing")
        break
      case "Fleet":
        navigate("/fleets")
        break
      case "Analysis":
        navigate("/analysis")
        break
      case "Team":
        navigate("/team")
        break
    }

    list[index].active = true
    setSlibarList(list)
  }

  return (
    <div>
      <div className='slibar'>
        <img className='slibar-img' src={navbar_logo} alt='No logo found' onClick={handleClickLogo} />
        <div className='slibar-select'>
          {slibarList.map((item, index) => {
            return (<div key={index} className='slibar-select-item'
              onClick={() => slibarTap(index, item.text)}>
              <div className={index == tabIndex ? 'nav-item selectd-item-active' : 'nav-item'}>
                <img style={{opacity: (index == 1 && index !== tabIndex) ? 0.6 : 1}} src={item.img} alt="" />
                <div>{item.text}</div>
              </div>
              <div className={index == tabIndex ? "trapezoid1 trapezoid1-active" : "trapezoid1"}></div>
            </div>)
          })}
        </div>
      </div>
    </div>
  )
}
